import {convertToSearchParams, getFormattedSearchParams} from './getSearchParamsByGridCode';
import {getSourceSearchParams} from './getSourceSearchParams';

/**
 * Writes grid params (queryId, rowIndex) into the `dataGrids` URL param via replaceState.
 *
 * Page is managed separately via `setPageInUrl` in `GridLifecycle` and is NOT
 * touched by this function — callers that only care about queryId do not
 * accidentally erase the current page number.
 *
 * @param gridCode — identifies the grid instance
 * @param queryId — server-side data query ID
 * @param rowIndex — entity row index for detail navigation (optional, defaults to '1')
 */
export const setSearchParamsByGridCode = (gridCode: string, queryId: string, rowIndex?: string) => {
  const currentLocation = window.location;

  const formattedSearchParams = getFormattedSearchParams();

  const currentUrlWithoutSearchParams = currentLocation.origin + currentLocation.pathname;

  formattedSearchParams[gridCode] = {
    gridCode,
    queryId,
    rowIndex: rowIndex ?? '1',
  };

  const sourceSearchParams = getSourceSearchParams();
  const sourceParams = sourceSearchParams ? `&${sourceSearchParams}` : '';

  window.history.replaceState(
    null,
    '',
    currentUrlWithoutSearchParams +
      '?' +
      new URLSearchParams(convertToSearchParams(formattedSearchParams)) +
      sourceParams
  );
};
